module.exports = __webpack_public_path__ + "static/media/role4.4cb63f00.png";